import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainURL, prodURL } from '../utils/common';
import { LeftSocialMediaIconUI } from '../components/LeftSocialMediaIconUI';
import { DownloadFileByFileStoreId } from '../components/DownloadFileByFileStoreId';

const Beup  = () => {
  const { t, i18n, ready } = useTranslation();
const increaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
      var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
      var fontSize = parseFloat(style); 
      el[i].style.fontSize = (fontSize + 1) + 'px';
    }
  };
  const decreaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
    var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
    var fontSize = parseFloat(style); 
    el[i].style.fontSize = (fontSize - 1) + 'px'; 
    }
  };
  return (
<>
  <section id="hero" className="hero hero2">
  <LeftSocialMediaIconUI />
    
    <div className="carousel-item active">
      <img src="assets/img/inner-bg2.png" className="img-fluid" alt />
      <div className="container"> <div className="section-main-heading2"></div></div>             
    </div>       	 		 
  </section>	  
  {/* End Slider */}
 
  <section className="section inner-pad1">
    <div className="container " >
      <div className="row">
        <div className="col-lg-3">
        <div className="site-menu  ">           
              <nav className="sidebar card py-2">
                <ul className="nav flex-column" id="nav_accordion">
                  <li className="nav-item"><Link className="nav-link fontSizeClass" to='/Mpnld'> {t("MPLAD")} </Link> </li>
                  <li className="nav-item "><Link className="nav-link fontSizeClass active1" to='/Beup'> {t("BEUP")} </Link></li>
                </ul>
              </nav>	   
            </div>
        </div>
        <div className="col-lg-9">
          <div className="container">
            <div className="row">
              <div className="inner-title"><h3 className="fontSizeClass">{t("Bidhayak Elaka Unnayan Prakalpa (BEUP)")}</h3>
              </div>
                <div id="accordion" className='col-lg-12'>
                   <p className='font-siz1'>Click the links below to find out the details and progress of work for various projects taken under the BEUP Scheme.</p> 
                   <p>
                    <DownloadFileByFileStoreId fileStoreId="cd51772f-cf26-460e-bc97-9131e4253077" label="The Kolkata Municipal Corporation BEUP Reports, 2011"  />
                    <DownloadFileByFileStoreId fileStoreId="c2962f7e-d530-4fa6-86db-0afae3d1f3aa" label="The Kolkata Municipal Corporation BEUP Reports, 2016"  />
                    <a className="dropdown-item" href={`${mainURL}/citizen/language-selection`}> {t("More Details on BEUP (eKMC 1.0)")} </a>
                    <a className="dropdown-item" href={`${prodURL}/contact-us/beup`}> {t("More Details on BEUP (eKMC 2.0)")} </a>
                   </p>

       
                </div>
            </div> 
          </div>
        </div>

        

      </div>
    </div>
    {/*   */}
  </section>
  
    </>
  )
}

export default Beup